import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setChatAlert} from "store/actions/chat";
import {changePlayOption} from "store/actions/playOption";
import {turnOffSelfieMode, turnOnSelfieMode} from "store/actions/selfie";
import {URL, PLAY_MODE_ACTION} from "utils";
import classNames from "classnames/bind";
import {DEFAULT_BTN_LIST, OPEN_METAVERSE_ABOUT, OPEN_METAVERSE_BTN_LIST} from "./constants";
import {isMobile} from "react-device-detect";
import ExitPopup from "components/IPXContents/Common/ExitPopup";
import HamburgerBtn from "images/topBtnOptions/ic_more.svg";
import {showPopUp} from "components/PopUp";
import ExitButtons from "./ExitButtons";
import {useClickOutside} from "hooks";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);
const videoElements = document.getElementsByTagName("video");

function TopBtnOptions({isIPXMode, onClickExit, status}) {
  const currentOption = useSelector(state => state.playOption);
  const excludeSelfieBtn = DEFAULT_BTN_LIST.slice().filter(item => item !== "selfie");
  const onlySelfieBtn = DEFAULT_BTN_LIST.slice().filter(item => item === "selfie");
  const showBtnList = isIPXMode ? OPEN_METAVERSE_BTN_LIST : excludeSelfieBtn;
  const [isbtnClickStatus, setIsBtnClickStatus] = useState(false);
  const moreBtnRef = useRef(null);
  const dispatch = useDispatch();

  let isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

  const moreBtnClickHandler = () => {
    dispatch(changePlayOption(null));
    setIsBtnClickStatus(!isbtnClickStatus);
  };

  useClickOutside(moreBtnRef, () => setIsBtnClickStatus(false));

  return (
    <div className={cn("bottom_options", isIPXMode && "ipx_ver")}>
      <div className={cn("etc_btn", status === "on" && "click")} ref={moreBtnRef}>
        <button className={cn("more_btn", isbtnClickStatus && "click")} type="button" onClick={moreBtnClickHandler}>
          <img alt="more" src={HamburgerBtn} />
        </button>

        <div className={cn("more_btn_box", isbtnClickStatus && "open")}>
          {onlySelfieBtn.map(btn => (
            <Button key={btn} option={btn} status={btn === currentOption ? "on" : "off"} />
          ))}

          {isFullscreen && <ExitButtons onClickExit={onClickExit} />}
        </div>
      </div>

      {showBtnList.map(btn => (
        <Button key={btn} option={btn} status={btn === currentOption ? "on" : "off"} />
      ))}
    </div>
  );
}

const Button = ({option, status}) => {
  const dispatch = useDispatch();
  const isSelfieMode = useSelector(state => state.selfie.isActivated);
  const chatAlert = useSelector(state => state.chat.alert);
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);

  useEffect(() => {
    if (!videoElements) return;
    if (videoElements.length === 0) return;
    videoElements.forEach(child => {
      child.muted = !isSoundPlaying;
    });
  }, [isSoundPlaying]);

  const handleButtonClick = (option, status) => {
    dispatch(changePlayOption(status === "on" ? null : option));
    switch (option) {
      case OPEN_METAVERSE_ABOUT:
        if (true) {
          showPopUp(
            <ExitPopup
              textSet={["Open Discord for", "CS Support"]}
              clickExit={() => {
                if (isMobile) {
                  if (window.android) {
                    window.android.openDiscord();
                  }
                  if (window.webkit) {
                    window.webkit.messageHandlers.openDiscord.postMessage({});
                  }
                }
              }}
            />,
            {
              defaultPadding: false,
              transparentBackground: true,
              clearOverHidden: true,
            },
          );
        } else {
          if (typeof window.open === "function") {
            window.open(URL.IPX_DISCORD);
          } else {
            window.location.href = URL.IPX_DISCORD;
          }
        }
        break;
      case PLAY_MODE_ACTION.SELFIE:
        return !isSelfieMode ? dispatch(turnOnSelfieMode()) : dispatch(turnOffSelfieMode());
        break;
      case PLAY_MODE_ACTION.CHAT:
        if (chatAlert) {
          dispatch(setChatAlert(false));
        }
        break;
      case PLAY_MODE_ACTION.SOUND:
        setIsSoundPlaying(!isSoundPlaying);
        break;
      default:
        break;
    }
  };

  const preventDefaultKeyPressed = e => {
    if (e.code === "Enter" || e.code === "Space") {
      e.preventDefault();
    }
  };

  return (
    <button
      type="button"
      className={cn(option === PLAY_MODE_ACTION.CHAT && chatAlert && "alert", status === "on" && "click")}
      onClick={() => handleButtonClick(option, status)}
      onKeyDown={preventDefaultKeyPressed}
    >
      <img src={require(`../../images/topBtnOptions/ic_${option}_${status}.svg`)} alt={option} />

      {option === PLAY_MODE_ACTION.SELFIE && <p>Selfie Mode</p>}
    </button>
  );
};

export default TopBtnOptions;
